<template>
    <div>
        <component
            :is="isSaved && data.model.possuiNovoEnvio ? 'rkm-form' : 'div'"
            ref="Form"
        >
            <rkm-table
                :fields="fields"
                :items="data.model.itens"
                hide-filters
                hide-pagination
                ref="Table"
                class="table-materiais"
            >
                <template v-slot:cell(enviado)="{ item }">
                    <template v-if="item.possuiEntradaComLote">
                        <template v-if="item.entradaItens.length > 0">
                            <div
                                v-for="(lote, i) in item.entradaItens"
                                :key="i"
                                class="enviado"
                            >
                                {{ lote.enviado }}
                            </div>
                        </template>

                        <template v-else>
                            0
                        </template>
                    </template>

                    <template v-else>
                        {{ item.enviado }}
                    </template>
                </template>

                <template v-slot:cell(recebido)="{ item }">
                    <template v-if="item.possuiEntradaComLote">
                        <template v-if="item.entradaItens.length > 0">
                            <div
                                v-for="(lote, i) in item.entradaItens"
                                :key="i"
                                :class="{ 'mb-2': i < item.entradaItens.length - 1 }"
                            >
                                <rkm-form-input
                                    :disabled="lote.enviado === 0"
                                    :validations="getRecebidoValidations(item, lote)"
                                    class="my-auto recebido"
                                    name="Recebido"
                                    number
                                    v-model="lote.recebido"
                                />
                            </div>
                        </template>

                        <template v-else>
                            <rkm-form-input
                                class="my-auto recebido"
                                disabled
                                value="0"
                            />
                        </template>
                    </template>

                    <template v-else>
                        <rkm-form-input
                            :disabled="item.enviado === 0"
                            :validations="getRecebidoValidations(item)"
                            class="my-auto recebido"
                            name="Recebido"
                            number
                            v-model="item.recebido"
                        />
                    </template>
                </template>

                <template v-slot:cell(lote)="{ item }">
                    <template v-if="item.possuiEntradaComLote">
                        <template v-if="item.entradaItens.length > 0">
                            <div
                                v-for="(lote, i) in item.entradaItens"
                                :key="i"
                                :class="{ 'mb-2': i < item.entradaItens.length - 1 }"
                            >
                                <rkm-form-input
                                    :disabled="!lote.possuiLote"
                                    :validations="validations.lote"
                                    @blur="validateLote(item, lote, i)"
                                    class="my-auto lote"
                                    name="Lote"
                                    uppercase
                                    v-model="lote.lote"
                                />
                            </div>
                        </template>

                        <template v-else>
                            <rkm-form-input
                                class="my-auto lote"
                                disabled
                            />
                        </template>
                    </template>

                    <template v-else>
                        -
                    </template>
                </template>

                <template v-slot:cell(validadeLote)="{ item }">
                    <template v-if="item.possuiEntradaComLote">
                        <template v-if="item.entradaItens.length > 0">
                            <div
                                v-for="(lote, i) in item.entradaItens"
                                :key="i"
                                :class="{ 'mb-2': i < item.entradaItens.length - 1 }"
                            >
                                <rkm-form-date-picker
                                    :disabled="!lote.possuiLote"
                                    :validations="validations.validadeLote"
                                    class="my-auto validade"
                                    name="Validade"
                                    v-model="lote.validadeLote"
                                    right
                                />
                            </div>
                        </template>

                        <template v-else>
                            <rkm-form-date-picker
                                class="my-auto validade"
                                disabled
                            />
                        </template>
                    </template>

                    <template v-else>
                        -
                    </template>
                </template>

                <template v-slot:cell(actions)="{ index }">
                    <rkm-button
                        @click="handleDestroy(index)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>

                <template
                    v-if="!isSaved"
                    #afterTable
                >
                    <div class="my-2">
                        <rkm-row>
                            <rkm-col class="text-right">
                                <h6 class="font-weight-bold">Quantidade de materiais inclusa: {{ data.model.itens.length }}</h6>
                            </rkm-col>
                        </rkm-row>
                    </div>
                </template>
            </rkm-table>
        </component>

        <rkm-area
            v-if="data.form.recebimentos.length > 0"
            title="Recebimentos anteriores"
        >
            <rkm-list
                :items="data.form.recebimentos"
                hide-filters
            >
                <template v-slot="{ item }">
                    <strong>{{ item.numeroRecebimento }}ª recebimento ({{ item.dataHora }})</strong>
                </template>

                <template v-slot:collapse="{ item }">
                    <div class="p-2">
                        <rkm-row>
                            <rkm-col>
                                <rkm-table
                                    :fields="getRecebimentosFields(item.numeroRecebimento === 1)"
                                    :items="item.itens"
                                    hide-filters
                                    hide-pagination
                                    class="table-materiais"
                                >
                                    <template v-slot:cell(enviado)="{ item }">
                                        <template v-if="item.possuiEntradaComLote">
                                            <template v-if="item.entradaItens.length > 0">
                                                <div
                                                    v-for="(lote, i) in item.entradaItens"
                                                    :key="`${i}${lote.lote}`"
                                                >
                                                    {{ lote.enviado }}
                                                </div>
                                            </template>

                                            <template v-else>
                                                0
                                            </template>
                                        </template>

                                        <template v-else>
                                            {{ item.enviado }}
                                        </template>
                                    </template>

                                    <template v-slot:cell(recebido)="{ item }">
                                        <template v-if="item.possuiEntradaComLote">
                                            <template v-if="item.entradaItens.length > 0">
                                                <div
                                                    v-for="(lote, i) in item.entradaItens"
                                                    :key="`${i}${lote.lote}`"
                                                >
                                                    {{ lote.recebido }}
                                                </div>
                                            </template>

                                            <template v-else>
                                                0
                                            </template>
                                        </template>

                                        <template v-else>
                                            {{ item.recebido }}
                                        </template>
                                    </template>

                                    <template v-slot:cell(lote)="{ item }">
                                        <template v-if="item.possuiEntradaComLote">
                                            <template v-if="item.entradaItens.length > 0">
                                                <div
                                                    v-for="(lote, i) in item.entradaItens"
                                                    :key="`${i}${lote.lote}`"
                                                >
                                                    {{ lote.lote || '-' }}
                                                </div>
                                            </template>

                                            <template v-else>
                                                -
                                            </template>
                                        </template>

                                        <template v-else>
                                            -
                                        </template>
                                    </template>

                                    <template v-slot:cell(validadeLote)="{ item }">
                                        <template v-if="item.possuiEntradaComLote">
                                            <template v-if="item.entradaItens.length > 0">
                                                <div
                                                    v-for="(lote, i) in item.entradaItens"
                                                    :key="`${i}${lote.lote}`"
                                                >
                                                    {{ lote.validadeLote || '-' }}
                                                </div>
                                            </template>

                                            <template v-else>
                                                -
                                            </template>
                                        </template>

                                        <template v-else>
                                            -
                                        </template>
                                    </template>
                                </rkm-table>
                            </rkm-col>
                        </rkm-row>
                    </div>
                </template>
            </rkm-list>
        </rkm-area>
    </div>
</template>

<script>
export default {
    computed: {
        validations() {

            return {
                lote: {
                    required: true,
                },
                validadeLote: {
                    required: true,
                },
            }
        },
        fields() {

            const fields = this.getFields()

            if (!this.isSaved) {

                return [
                    fields.material,
                    fields.quantidade,
                    fields.actions
                ]
            }

            if (this.data.form.recebimentos.length === 0) {

                if (this.data.model.possuiNovoEnvio) {

                    return [
                        fields.material,
                        fields.requisitado,
                        fields.enviado,
                        fields.recebido,
                        fields.lote,
                        fields.validadeLote
                    ]
                }
                else {

                    return [
                        fields.material,
                        fields.quantidade
                    ]
                }
            }
            else {

                if (this.data.model.possuiNovoEnvio) {

                    return [
                        fields.material,
                        fields.recebeuAnteriormente,
                        fields.restanteRequisitado,
                        fields.enviado,
                        fields.recebido,
                        fields.lote,
                        fields.validadeLote
                    ]
                }
                else {

                    return [
                        fields.material,
                        fields.recebeuAnteriormente,
                        fields.restanteRequisitado
                    ]
                }
            }
        }
    },
    methods: {
        async validate() {

            if (this.isSaved && this.data.model.possuiNovoEnvio) {

                return await this.$refs.Form.validate()
            }

            return true
        },
        getFields() {

            return {
                material: {
                    key: 'material.descricaoCompleta',
                    label: 'Material',
                    sortable: true,
                },
                quantidade: {
                    key: 'quantidade',
                    label: 'Quantidade',
                    class: 'col-min text-center'
                },
                requisitado: {
                    key: 'requisitado',
                    label: 'Requisitado',
                    class: 'col-min text-center'
                },
                recebeuAnteriormente: {
                    key: 'recebeuAnteriormente',
                    label: 'Recebeu anteriormente',
                    class: 'col-min text-center'
                },
                restanteRequisitado: {
                    key: 'restanteRequisitado',
                    label: 'Restante requisitado',
                    class: 'col-min text-center'
                },
                enviado: {
                    key: 'enviado',
                    label: 'Enviado',
                    class: 'col-min text-center'
                },
                recebido: {
                    key: 'recebido',
                    label: 'Recebido',
                    class: 'col-min text-center'
                },
                lote: {
                    key: 'lote',
                    label: 'Lote',
                    class: 'col-min text-center'
                },
                validadeLote: {
                    key: 'validadeLote',
                    label: 'Validade',
                    class: 'col-min text-center'
                },
                actions: {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                }
            }
        },
        getRecebimentosFields(isPrimeiroRecebimento) {

            const fields = this.getFields()

            return isPrimeiroRecebimento ? [
                fields.material,
                fields.requisitado,
                fields.enviado,
                fields.recebido,
                fields.lote,
                fields.validadeLote
            ] : [
                fields.material,
                fields.recebeuAnteriormente,
                fields.restanteRequisitado,
                fields.enviado,
                fields.recebido,
                fields.lote,
                fields.validadeLote
            ]
        },
        getRecebidoValidations(item, lote = null) {

            return {
                required: true,
                max_value: lote ? lote.enviado : item.enviado
            }
        },
        validateLote(item, lote, index) {

            if (!lote.lote) return

            let valid = true

            item.entradaItens.filter((_, i) => i !== index).forEach(currentLote => {

                if (currentLote.lote === lote.lote) {

                    valid = false

                    return false
                }
            })

            if (!valid) {

                this.showValidationNotification('O mesmo lote já foi incluso.')

                lote.lote = null
            }
        },
        handleDestroy(index) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o material?',
                async () => this.data.model.itens.splice(index, 1)
            )
        },
    },
    props: {
        data: { type: Object, required: true },
        isSaved: { type: Boolean, required: true },
    }
}
</script>

<style scoped>
.table-materiais >>> .enviado { line-height: 40px; }
.table-materiais >>> .recebido { min-width: 100px; }
.table-materiais >>> .lote { min-width: 150px; }
.table-materiais >>> .validade { min-width: 180px; }
</style>